import { PREFECTURES } from "@/utils/prefecture";

interface SplitAddress {
  addressPrefecture: string;
  address: string;
}

export const splitPrefectureFromAddress = (address: string): SplitAddress => {
  const normalizedAddress = address.trim();
  const prefecture = PREFECTURES.find(({ name }) =>
    normalizedAddress.startsWith(name)
  );

  if (!prefecture) {
    return { addressPrefecture: "", address: normalizedAddress };
  }

  return {
    addressPrefecture: prefecture.name,
    address: normalizedAddress.slice(prefecture.name.length).trim(),
  };
};

/** 住所の欄に都道府県から書かれていたら、選んだ都道府県と重ならないよう先頭の都道府県を除く */
export const removePrefectureFromAddress = (
  addressPrefecture: string,
  address: string
): string => {
  const normalizedPrefecture = addressPrefecture.trim();
  const normalizedAddress = address.trim();
  if (
    normalizedPrefecture === "" ||
    !normalizedAddress.startsWith(normalizedPrefecture)
  ) {
    return normalizedAddress;
  }

  return normalizedAddress.slice(normalizedPrefecture.length).trim();
};

export const buildFullAddress = (
  addressPrefecture: string,
  address: string
): string => {
  const normalizedPrefecture = addressPrefecture.trim();
  const normalizedAddress = address.trim();
  if (
    normalizedPrefecture === "" ||
    normalizedAddress.startsWith(normalizedPrefecture)
  ) {
    return normalizedAddress;
  }

  return `${normalizedPrefecture}${normalizedAddress}`;
};
